<!-- TODO Itt lehet járhatóbb út lenne, és jobb teljesítmény, ha nem lenne külön komponensbe a tab-rendszer -->

<app-main-content-card>
  <div class="title-bar">
    <h1 class="my-4">
      <ng-container [ngSwitch]="path">
        <ng-container *ngSwitchCase="'basic-data'">
          {{ "MERCHANT.TITLE.BASIC_DATA" | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="'sites'">
          {{ "MERCHANT.TITLE.SITE_DATA" | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="'marketing-data'">
          {{ "MERCHANT.TITLE.MARKETING_DATA" | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="'contact-data'">
          {{ "MERCHANT.TITLE.CONTACT_DATA" | translate }}
        </ng-container>
      </ng-container>
    </h1>
  </div>

  <app-merchant-tabs [tabPanel]="tabPanel"></app-merchant-tabs>
  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</app-main-content-card>
